import { render, staticRenderFns } from "./PrdProjectInfoPage.vue?vue&type=template&id=12f2ada6&scoped=true&"
import script from "./PrdProjectInfoPage.vue?vue&type=script&lang=js&"
export * from "./PrdProjectInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./PrdProjectInfoPage.vue?vue&type=style&index=0&id=12f2ada6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f2ada6",
  null
  
)

export default component.exports